/**
 * Spacer/Divider Widget (Story 5.24, Task 5)
 *
 * Renders visual separation between report sections:
 * - spacing: empty vertical space (no visible element)
 * - line: solid horizontal rule
 * - dashed-line: dashed horizontal rule
 *
 * No text content, no title display, no auto-sizing.
 */

import type { WidgetConfig } from "../../../lib/templateUtils";

interface SpacerDividerWidgetProps {
  widget: WidgetConfig;
}

type SpacerStyle = "spacing" | "line" | "dashed-line";

export function SpacerDividerWidget({ widget }: SpacerDividerWidgetProps) {
  const config = widget.config as { style?: SpacerStyle; height?: number };
  const style = config.style ?? "line";

  return (
    <div data-testid="widget-type-spacer-divider" className="flex h-full items-center px-4">
      {style === "spacing" && (
        <div data-testid="spacer-divider-spacing" className="w-full" />
      )}
      {style === "line" && (
        <hr data-testid="spacer-divider-line" className="w-full border-t border-border" />
      )}
      {style === "dashed-line" && (
        <hr data-testid="spacer-divider-dashed" className="w-full border-t border-dashed border-border" />
      )}
    </div>
  );
}
